import React, {Component} from 'react';
import { connect } from 'react-redux';
import imgProfile from '../../../FO/resources/img/user-icon.png';
import { API_URL } from "../../../SHARED/config/apiEndpoints";
import Comment from "./container/comment.component";
import AddCommentForm from './addcommentForm';
import {isEmpty} from '../../helpers/general.helper';

class Comments extends Component{
    constructor(props){
        super(props);
    }

    getComment = () => {
        if (this.props.comments){  
            if (this.props.comments.length !== 0){ 
                return this.props.comments.map( (comment, i) => {
                    return <Comment 
                        key={i}
                        image = {comment.comment_author_image ? API_URL + comment.comment_author_image : imgProfile}
                        date = {comment.comment_created}
                        name = {comment.comment_author_first_name + " " + comment.comment_author_last_name} 
                        text = {comment.comment_text}
                        />
                    }
                );
            }
            else {
                return <p className="text-white no-comments">Nu exista nici un comentariu adăugat</p>
            }
        }
    }

    getImageComment = () => {
        if (!isEmpty(this.props.userProfile)){
            return this.props.userProfile.picture !== "" ? API_URL + this.props.userProfile.picture : imgProfile
        } else {
            return imgProfile;
        }
    }

    render() {
        return (
            <div className={this.props.className + " comments"}>
                <h4 className="comment-border text-white">{ this.props.headline }</h4>
                {this.getComment()}
                { this.props.showInput ?
                    <div className="row p-3">
                        <div className="col-xl-1 col-lg-2">
                            <img alt={'Autor'} className="p-2 rounded-circle d-none d-sm-none d-md-none d-lg-block" src={this.getImageComment()}/>
                        </div>
                        <div className="col-xl-11 col-lg-10 input-cmt">
                            <AddCommentForm onSubmit={this.props.addComment} />
                        </div>
                    </div>
                : ''}
            </div>  
        );
    }
}


const mapStateToProps = state => ({
    userProfile: state.profile.userDetails
});

export default connect(mapStateToProps,{})(Comments);


// WEBPACK FOOTER //
// ./src/SHARED/components/comments/comments.component.js